module.exports = "<div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.html
// module id = 43
// module chunks = 0